export type SiteSection = "app" | "pricing" | "privacy" | "terms";

export const siteNavigationItems = (signedIn: boolean) => [
  { href: "/", section: "app" as const, label: signedIn ? "Dashboard" : "Home" },
  { href: "/pricing", section: "pricing" as const, label: "Pricing" },
  { href: "/privacy", section: "privacy" as const, label: "Privacy" },
  { href: "/terms", section: "terms" as const, label: "Terms" }
];

export const showSignInLink = (signedIn: boolean, active: SiteSection) => !signedIn && active !== "app";
